export interface IKYCLevel {
  id: number
  user_id: number
  level: number
  status: TKYCStatus
  submit_at: string | null
  review_at: string | null
  created_at: string
  updated_at: string
}

export type TKYCStatus = 0 | 1 | 2 | 3

export const CKYC_STATUSES = {
  NOT_SUBMITTED: 0,
  SUBMITTED: 1,
  APPROVED: 2,
  REJECTED: 3,
} as const
